export default function formatPercent(_value: number) {
  let value = _value;
  if (typeof value !== "number") {
    value = parseFloat(value);
  }

  return `${(value * 100).toFixed(0)}%`;
}
